import { render, staticRenderFns } from "./addIndustryDialog.vue?vue&type=template&id=3e54c724&scoped=true"
import script from "./addIndustryDialog.vue?vue&type=script&lang=js"
export * from "./addIndustryDialog.vue?vue&type=script&lang=js"
import style0 from "./addIndustryDialog.vue?vue&type=style&index=0&id=3e54c724&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e54c724",
  null
  
)

export default component.exports